import {
    EDUCATION_FETCHING,
    EDUCATION_FAILED,
    EDUCATION_SUCCESS
} from "../actions/types";

const initialState = {
    result: null,
    isFetching:false,
    isError: false
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case EDUCATION_FETCHING:
            return { ...state, result: null, isFetching: true, isError: false };
        case EDUCATION_FAILED:
            return { ...state, result: null, isFetching: false, isError: true };
        case EDUCATION_SUCCESS:
            return { ...state, result: payload, isFetching: false, isError: false };
        default:
            return state;
    }
};